export const playNotificationSound = () => {
  const chatPath = '/whatsapp/chat';
  const isChatPage = window.location.pathname === chatPath;
  const isWindowHidden = document.visibilityState === 'hidden';

  if (isChatPage && !isWindowHidden) return;

  const play = () => {
    const now = Date.now();
    const lastPlay = localStorage.getItem('last_notification_time');
    if (lastPlay && (now - parseInt(lastPlay) < 1000)) return;
    
    localStorage.setItem('last_notification_time', now.toString());
    const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3');
    audio.play().catch(err => {});
  };

  if (!isWindowHidden) {
    play();
  } else {
    setTimeout(play, 200);
  }
};
